import React from 'react';
import { CustomSelect, Input } from '../../../../components';
import { FormControl, FormControlLabel, Radio, RadioGroup, Switch } from '@mui/material';

const axles = [
  { key: 'front', label: 'Front Axle' },
  { key: 'rear', label: 'Rear Axle' },
  { key: 'second', label: '2nd Axle', toggleField: 'isSecondEnabled' },
  { key: 'third', label: '3rd Axle', toggleField: 'isThirdEnabled' },
  { key: 'spare', label: 'Spare Tire', toggleField: 'isSpareEnabled' }
];

const tire_types = [
  { value: 'P', label: 'P' },
  { value: 'LT', label: 'LT' },
  { value: 'C', label: 'C' },
  { value: 'ST', label: 'ST' },
  { value: 'T', label: 'T' },
];

const tire_construction = [
  { value: 'B', label: 'B' },
  { value: 'D', label: 'D' },
  { value: 'R', label: 'R' },
];

const tire_speed_rating = [
  { value: "A1", label: "A1" },
  { value: "A2", label: "A2" },
  { value: "A3", label: "A3" },
  { value: "A4", label: "A4" },
  { value: "A5", label: "A5" },
  { value: "A6", label: "A6" },
  { value: "A7", label: "A7" },
  { value: "A8", label: "A8" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
  { value: "F", label: "F" },
  { value: "G", label: "G" },
  { value: "J", label: "J" },
  { value: "K", label: "K" },
  { value: "L", label: "L" },
  { value: "M", label: "M" },
  { value: "N", label: "N" },
  { value: "P", label: "P" },
  { value: "Q", label: "Q" },
  { value: "R", label: "R" },
  { value: "S", label: "S" },
  { value: "T", label: "T" },
  { value: "U", label: "U" },
  { value: "H", label: "H" },
  { value: "V", label: "V" },
  { value: "Z", label: "Z" },
  { value: "W", label: "W" },
  { value: "(W)", label: "(W)" },
  { value: "Y", label: "Y" },
  { value: "(Y)", label: "(Y)" }
];

const TireAndRimData = ({ form }) => {
  return (
    <div>
      <h3 className="mb-4">Tire and Rim Data</h3>

      {axles.map(({ key, label, toggleField }) => (
        <div key={key} className="mb-1 rounded p-3">
          <div className="mb-1">
            <h5 className="">{label}</h5>
            {toggleField && (
              <Switch
                checked={form.values.tireData[toggleField]}
                onChange={(e) => form.setFieldValue(`tireData.${toggleField}`, e.target.checked)}
              />
            )}
          </div>

          {(!toggleField || form.values.tireData[toggleField]) && (
            <div className="tire-fields">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <Input
                      label="Tire Data"
                      {...form.getFieldProps(`tireData.${key}TireData`)}
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value === '' ? null : e.target.value;
                        form.setFieldValue(`tireData.${key}TireData`, value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <Input
                      label="Rim Data"
                      {...form.getFieldProps(`tireData.${key}RimData`)}
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value === '' ? null : e.target.value;
                        form.setFieldValue(`tireData.${key}RimData`, value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <Input
                      label="Cold Tire Pressure (PSI)"
                      {...form.getFieldProps(`tireData.${key}ColdTirePressurePSI`)}
                      type="number"
                      onChange={(e) => {
                        const value = e.target.value === '' ? null : Number(e.target.value);
                        form.setFieldValue(`tireData.${key}ColdTirePressurePSI`, value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <Input
                      label="Cold Tire Pressure (kPa)"
                      {...form.getFieldProps(`tireData.${key}ColdTirePressureKPA`)}
                      type="number"
                      onChange={(e) => {
                        const value = e.target.value === '' ? null : Number(e.target.value);
                        form.setFieldValue(`tireData.${key}ColdTirePressureKPA`, value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label id={`${key}-axle-type`} className="mb-1 d-block">
                      Axle Type
                    </label>
                    <FormControl fullWidth>
                      <RadioGroup
                        aria-labelledby={`${key}-axle-type`}
                        {...form.getFieldProps(`tireData.${key}AxleType`)}
                        className="flex-row gap-2"
                        defaultValue="single"
                        onChange={(e) => {
                          form.setFieldValue(`tireData.${key}AxleType`, e.target.value);
                        }}
                      >
                        <FormControlLabel value="single" control={<Radio />} label="Single" />
                        <FormControlLabel value="dual" control={<Radio />} label="Dual" />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};


export default TireAndRimData;
